import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\".8\" clip-path=\"url(#a)\"><path d=\"M4.855 11.047H1.609v3.634h3.246z\"></path><path d=\"M8.097 8.83H4.852v5.848h3.245zM11.347 6.702H8.102v7.976h3.245z\"></path><path d=\"M15.731 4.487H14.59v10.192h-3.243V4.487h-1.144L12.97 1.32zM.266 14.679H15.61\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M.066 1.121h15.867v13.757H.066z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }